import React from 'react';

import { Clickable, Hoverable, Wrapper as ButtonWrapper, withBlockTypeConfigPropsV2 } from '../common/Button.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import Utilities from '../common/Utilities.jsx';

const injectStringIntoDesign = (design, injectString, after = false) => {
    let index;
    if (after) {
        index = design.indexOf('</span>');
    } else {
        index = design.indexOf('<span');
        if (index >= 0) {
            index = design.indexOf('>', index) + 1;
        } else {
            return design;
        }
    }
    if (index > 0) {
        return design.substring(0, index) + injectString + design.substring(index);
    }
    return design;
}
function _ModalButtonComponent(props) {
    let ButtonComponent = Clickable;
    let hoverProps;
    if (props.hoverProps != undefined) {
        ButtonComponent = Hoverable;
        hoverProps = { ...props.hoverProps };
    }
    const handleClick = (_, e) => {
        if (e) {
            e.stopPropagation();
        }
        if (props.onButtonClick) {
            props.onButtonClick(props.type);
        }
    }
    const style = {}
    Utilities.copyObject(props.style, style);
    if (props.builder || props.disabled) {
        style.pointerEvents = 'none';
    }
    let className = 'btn btn--whitelabel btn--modal--nav btn--custom2 richText';
    if (props.className) {
        className += ` ${props.className}`;
    }
    let design = props.design || Layout.wrapTextForEditor({ text: '' });
    let arrow;
    if (props.blockConfig?.block?.arrowVisible) {
        switch (props.blockType) {
            case Name.Block.ModalButtonNext:
                arrow = `<span class="i i-arrow-right"></span>`
                design = injectStringIntoDesign(design, arrow, true);
                if (hoverProps.design) {
                    hoverProps.design = injectStringIntoDesign(hoverProps.design, arrow, true);
                }
                break;
            case Name.Block.ModalButtonPrevious:
                arrow = `<span class="i i-arrow-left"></span>`
                design = injectStringIntoDesign(design, arrow);
                if (hoverProps.design) {
                    hoverProps.design = injectStringIntoDesign(hoverProps.design, arrow);
                }
                break;
        }
    }
    return (
        <ButtonWrapper {...props}>
            <ButtonComponent
                className={className}
                design={design}
                hoverProps={hoverProps}
                style={style}
                type="button"
                onClick={handleClick} />
        </ButtonWrapper>
    )
}
const ModalButtonComponent = withBlockTypeConfigPropsV2(_ModalButtonComponent);
export default { Component: ModalButtonComponent };